@import '../../style/index';
@import '~@vime/core/themes/default.css';

:host {
  display: block;
  margin-bottom: rem-calc(32px);

  .center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .video-player {
    --vm-blocker-z-index: -1;
    --vm-controls-bg: #000000b3;
    --vm-player-border-radius: 0px;
  }

  .video-opacity {
    opacity: 0;
  }

  .play-button {
    background-color: var(--colors-primary-base);
    border: none;
    border-radius: 50%;
    color: var(--colors-basic-black);
    text-align: center;
    width: rem-calc(75px);
    height: rem-calc(75px);
    cursor: pointer;
    z-index: 6;
  }

  .play-icon {
    width: rem-calc(32px);
    height: rem-calc(32px);
  }

  .controls {
    align-items: center;
  }

  .scrubber {
    --vm-scrubber-loading-stripe-size: 0px;
  }

  .slider {
    --vm-slider-track-height: 6px;
    --vm-slider-track-focused-height: 8px;
    --vm-slider-thumb-height: 16px;
    --vm-slider-thumb-width: 16px;
    --vm-slider-value-color: var(--colors-primary-base);
    --vm-slider-track-color: var(--colors-grey-background);
    --vm-slider-thumb-bg: var(--colors-primary-base);
  }

  .scrim {
    background-color: #ffffffe6;

    --vm-scrim-z-index: 0;
  }

  .overlay {
    width: 85%;
    text-align: center;

    p {
      margin-top: 0;
      line-height: 1.5;
      font-family: $font-family-regular;
      font-size: rem-calc(8px);

      @include small-up {
        font-size: rem-calc(10px);
      }
    }

    .text-normal {
      @include medium-up {
        font-size: rem-calc(14px);
      }
    }

    .text-half-width {
      @include medium-up {
        font-size: rem-calc(9px);
      }

      @include large-up {
        font-size: rem-calc(14px);
      }
    }

    .button-container {
      display: flex;
      justify-content: center;
    }

    .agree {
      width: 100%;
      max-width: 320px;
    }
  }

  .duration {
    position: absolute;
    bottom: rem-calc(10px);
    right: rem-calc(10px);
    color: white;
    background-color: rgb(0 0 0 / 80%);
    border-radius: 4px;
    padding: rem-calc(2px) rem-calc(8px);
    line-height: normal;
    font-size: rem-calc(12px);

    @include layer-normal-top();
  }
}
